import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LoyaltyWebsiteFacade, LoyaltyWebsiteStateModule } from './+state';
import { LoyaltyWebsiteService } from './services';

@NgModule({
  imports: [CommonModule, LoyaltyWebsiteStateModule],
})
export class PagesLoyaltyWebsiteModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: PagesLoyaltyWebsiteModule,
      providers: [LoyaltyWebsiteFacade, LoyaltyWebsiteService],
    };
  }
}
